import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Text,
} from '../../components';
import {
  getCarrier,
} from '../../modules/selectors';
import api from '../../utils/services';

const propTypes = {
  carrier: PropTypes.shape({
    carrierId: PropTypes.number,
    carrierName: PropTypes.string,
  }),
};
const defaultProps = {
  carrier: null,
};

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      planCount: null,
      carrierCount: null,
    };
  }

  componentDidMount() {
    this.getCarrierCount();
    this.getPlanCount();
  }

  componentDidUpdate(prevProps) {
    const { carrier } = this.props;
    if (prevProps.carrier !== carrier) {
      this.getPlanCount();
    }
  }

  getPlanCount = () => {
    const { carrier: { carrierId } } = this.props;
    if (carrierId) {
      api.getPlansCount(carrierId)
        .then((planCounts) => {
          this.setState({
            planCount: planCounts,
          });
        });
    }
  }

  getCarrierCount = () => {
    api.getCarriers(1000)
      .then((data) => {
        this.setState({ carrierCount: data.length });
      });
  }

  render() {
    const { planCount, carrierCount } = this.state;
    const { carrier: { carrierName } } = this.props;
    let carrierNameMarkup = null;
    let planCountMarkup = null;
    let carrierCountMarkup = null;

    if (carrierName !== null) {
      carrierNameMarkup = (
        <Text fontWeight="semiBold">
          {`Carrier Name: ${carrierName}`}
        </Text>
      );
    }
    if (planCount !== null) {
      planCountMarkup = (
        <Text fontWeight="semiBold">
          {`Plan Count: ${planCount}`}
        </Text>
      );
    }
    if (carrierCount !== null) {
      carrierCountMarkup = (
        <Text fontWeight="semiBold">
          {`Carrier Count: ${carrierCount === 1000 ? '>= 1000' : carrierCount}`}
        </Text>
      );
    }


    return (
      <div>
        {carrierNameMarkup}
        {planCountMarkup}
        {carrierCountMarkup}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    carrier: getCarrier(state),
  };
}


Statistics.propTypes = propTypes;
Statistics.defaultProps = defaultProps;
export default connect(mapStateToProps)(Statistics);
